/**
 * JSON-LD オブジェクトを `<script type="application/ld+json">` に注入できる文字列に変換する。
 *
 * `<` を Unicode エスケープ（`<`）に置換することで、値に `</script>` などが含まれていても
 * script タグを途中で閉じられず、マークアップ注入 / XSS を防ぐ。`<` は JSON として解析すると
 * `<` に復元されるため、構造化データの解釈には影響しない。
 *
 * @see https://schema.org
 */
export function serializeJsonLd(jsonLd: object): string {
  return JSON.stringify(jsonLd).replace(/</g, '\\u003c');
}
